export default __webpack_public_path__ + "static/media/map.391b8f4e.png";